import axios from "axios";
import {hostWithPrefix} from "../Constructor/common/ApiCommon";
import {getQueryString} from "../OutputForms/Api";

export function getFileByMaterialIdAndVersion(materialId, version) {
    return axios({
        url: 'http://' + hostWithPrefix + '/archive/materials/' + materialId + '/download?'
            + (version == undefined ? '' : 'version=' + version), //your url
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        responseType: 'blob', // important
    })
}

export function getReport() {
    return axios({
        url: 'http://' + hostWithPrefix + '/archive/materials/report',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        responseType: 'blob', // important
    })
}

export function deleteMaterialById(materialId, version) {
    const withVersion = '/version/' + version
    return axios({
        url: 'http://' + hostWithPrefix + '/archive/materials/' + materialId + ''
            + (version === undefined || version == null ? '' : withVersion), //your url
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        }
    })
}

export function deleteFileVersion(materialId, version) {

    const str = materialId.toString() + '/' + 'version' + '/' + version

    return axios({
        url: 'http://' + hostWithPrefix + '/archive/materials/' + str, //your url
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        }
    })
}

export function getAll(filters, sort, asc) {
    let qs = getQueryString(filters)
    if (sort !== undefined) {
        qs += "&sort=" + sort + "&asc=" + asc
    }
    return axios({
        url: 'http://' + hostWithPrefix + '/archive/materials' + qs,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    })
}

export function getFileById(materialId) {
    return axios({
        url: 'http://' + hostWithPrefix + '/archive/materials/' + materialId,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        responseType: 'application/json', // important
    })
}

export function createNewMaterial(filename, stationId, file, year, notes) {
    const formData = new FormData();
    formData.append('name',filename)
    formData.append('file',file)
    formData.append('year',year)
    formData.append('notes', notes)
    formData.append('stationId',stationId)

    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }

    return axios.post('http://' + hostWithPrefix + '/archive/materials/upload', formData, config)
}

export function addNewVersion(file, notes, materialsId) {
    const formData = new FormData();
    formData.append('file',file)
    formData.append('notes',notes)

    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }

    return axios.post('http://' + hostWithPrefix + '/archive/materials/' + materialsId + '/upload', formData, config)
}